import { Dispatch } from "redux";
import apiUrl from "../../../config/apiUrl";
import fetchUrl from "../../../utils/fetchUrl";
import {
  UserDispatchTypes,
  USER_SUCCESS,
  USER_FAILED,
  USER_LOADING,
  USER_WALLET_SUCCESS,
  USER_SET_TOTAL_ASSET,
  RESET_USER,
} from "./UserActionType";

export const GetUser = () => async (dispatch: Dispatch<UserDispatchTypes>) => {
  try {
    dispatch({
      type: USER_LOADING,
    });

    const response = await fetchUrl({
      url: `${apiUrl}profile`,
      method: "GET",
    });

    dispatch({
      type: USER_SUCCESS,
      payload: {
        user: response?.data.data,
      },
    });
  } catch (e) {
    dispatch({
      type: USER_FAILED,
    });
  }
};

export const GetUserWallet =
  () => async (dispatch: Dispatch<UserDispatchTypes>) => {
    // console.log('get user wallet called');
    try {
      dispatch({
        type: USER_LOADING,
      });

      const response = await fetchUrl({
        url: `${apiUrl}wallet/find-all`,
        method: "GET",
      });
      // sort to irt came first in lists;
      let sorted = response?.data.data.sort(function (x: any, y: any) {
        return x.currency === "IRT" ? -1 : y.currency === "IRT" ? 1 : 0;
      });
      // console.log("sorted", sorted);
      dispatch({
        type: USER_WALLET_SUCCESS,
        payload: {
          wallet: sorted,
        },
      });
    } catch (e) {
      dispatch({
        type: USER_FAILED,
      });
    }
  };

export const SetUserTotalAsset =
  (total: number) => (dispatch: Dispatch<UserDispatchTypes>) => {
    try {
      dispatch({
        type: USER_SET_TOTAL_ASSET,
        payload: {
          totalAsset: total,
        },
      });
    } catch (e) {
      dispatch({
        type: USER_SET_TOTAL_ASSET,
        payload: {
          totalAsset: 0,
        },
      });
    }
  };

export const ResetUserData = () => (dispatch: Dispatch<UserDispatchTypes>) => {
  try {
    dispatch({
      type: RESET_USER,
    });
  } catch (e) {
    dispatch({
      type: RESET_USER,
    });
  }
};
